import tokiot from './tokiot';
import amap from './amap';
import ys from './ys';
import flv from './flv';

export default {
    tokiot, amap,ys,flv
};